module.exports = __webpack_public_path__ + "img/contact_phone.db7c9ec1.svg";